@if (showGrid()) {
<div class="simple-planet-grid-panel">
  <h3 [class]="sideLabelClass()">{{ sideLabel() }}</h3>

  <div class="simple-planet-rows">
    @for (group of rowGroups(); track group.key) {
      <!-- Groep = positioneringskader: de pijl hangt naast het paneel, gecentreerd op deze rijen. -->
      <div class="simple-planet-group">
        @for (row of group.rows; track row.activation.id) {
          <hd-simple-planet-block
            [activation]="row.activation"
            [side]="side()"
            [displayConfig]="row.displayConfig"
            [fixingState]="row.fixingState"
            [showHdKeynotes]="showHdKeynotes()"
            (blockClicked)="planetActivationClicked.emit($event)"
          ></hd-simple-planet-block>
        }
        @if (group.arrow; as arrow) {
          <hd-transformation-arrow
            class="simple-transformation-arrow"
            [class.is-personality]="side() === 'personality'"
            [tone]="arrow.tone"
            [side]="side()"
            [category]="arrow.category"
            [colorConfig]="colorConfig()"
            [showHdKeynotes]="showHdKeynotes()"
            [relatedGates]="arrow.gates"
            data-test-id="simple-grid-transformation-arrow"
            (phsBlockClicked)="onArrowClicked(arrow, $event)"
          ></hd-transformation-arrow>
        }
      </div>
    }

    @if (chiron(); as chironVm) {
      <!-- Chiron: blijft gedimd (geen activatie), maar opent de gate-info van haar poort. -->
      <button
        type="button"
        class="simple-chiron-row"
        [class.is-personality]="side() === 'personality'"
        [class.is-design]="side() === 'design'"
        [title]="chironVm.tooltip"
        data-test-id="simple-grid-chiron"
        (click)="onChironClick($event)"
      >
        <span class="simple-planet-glyph">{{ chironVm.glyph }}</span>
        <span class="simple-planet-gate-line">
          <span class="gate">{{ chironVm.gate }}</span><span class="dot">.</span><span class="line">{{ chironVm.line }}</span>
        </span>
        <span class="simple-planet-arrows"></span>
      </button>
    }
  </div>
</div>
}
